import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useQuery } from '~~utils/CommonUtils';
import { TABLET_WIDTH } from '~~elements/Const';

const StyledDiv = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  .first-base-header {
    &--pic {
      border-radius: 50%;
      width: 6rem;
      height: 6rem;
      margin-right: 0.5rem;
      object-fit: cover;
    }
    &--name {
      font-size: 1.2rem;
    }
    &--sub-name {
      font-size: 0.8rem;
    }
    &--change {
      color: #aaaaaa;
      display: flex;
      align-items: center;
      font-size: 0.8rem;

      select,
      option {
        color: #aaaaaa;
        &:hover,
        &:focus {
          display: inline-block;
        }
      }

      &-hint {
        font-size: 0.8rem;
        margin-left: 3rem;
      }
      select {
        display: none;
      }

      &:hover,
      &:focus {
        select {
          display: inline-block;
        }
      }
    }
  }

  @media (max-width: ${TABLET_WIDTH}) {
    flex-direction: column;
    text-align: center;
    align-items: center;
    .first-base-header {
      &--change-hint {
        margin-left: 0;
      }
    }
  }
`;

const FirstBaseHeader = ({ firstBases, teamIndex, setTeamIndex }) => {
  const query = useQuery();
  useEffect(() => {
    const fbindex = query.get('fbindex');
    const firstBaseIndex = parseInt(fbindex);
    if (!fbindex || firstBaseIndex === teamIndex) {
      return;
    }

    if (Number.isNaN(firstBaseIndex) || firstBaseIndex < 0 || firstBaseIndex > firstBases.length - 1) {
      return query.delete('fbindex');
    }

    setTeamIndex(firstBaseIndex);
  }, [query, firstBases, setTeamIndex, teamIndex]);

  const handleTeamChange = (e) => {
    query.set({ fbindex: e.target.value });
  };

  if (firstBases.length === 0) {
    return <></>;
  }

  return (
    <StyledDiv>
      <img className="first-base-header--pic" src={firstBases[teamIndex].info.icon_url} alt="" />
      <div>
        <div className="first-base-header--name">{firstBases[teamIndex].info.name}</div>
        <div className="first-base-header--sub-name">{firstBases[teamIndex].info.full_name}</div>
      </div>
      {firstBases.length > 1 && (
        <label className="first-base-header--change" tabIndex="-1">
          <div className="first-base-header--change-hint">切換</div>
          <select value={teamIndex} onChange={handleTeamChange}>
            {firstBases.map((team, index) => (
              <option key={index} value={index}>
                {team.info.name}
              </option>
            ))}
          </select>
        </label>
      )}
    </StyledDiv>
  );
};

export default FirstBaseHeader;
